export const version = "ethers/5.8.0";
